import { connect } from 'react-redux';
import cn from 'classnames';

import { startAgainMobileQuestioner } from '../../actions/steps';

import styles from './ProgressPage.module.css';

const ImportantNote = (props) => {
  const { 
    startAgainMobileQuestioner,
  } = props;

  return (
    <div className={cn(styles.noteWrapper)}>
      <div className={styles.importantNoteWrapper}>
        <div className={styles.strictMenu}>
          <div className={styles.strictTitle}>
            Unfortunately, your diet is too strict
          </div>
          <div className={styles.strictSubtitle}>
            Your diet is too strict, and we don’t know yet how to create balanced meal plan for you. We will contact you ASAP once we have a solution for you.
          </div>
        </div>
        <button
          className="green-button"
          onClick={startAgainMobileQuestioner}
        >
          Back
        </button>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  startAgainMobileQuestioner,
};

export default connect(null, mapDispatchToProps)(ImportantNote);